<template>
<div class="size margin">

  <div class="example">
    <titleComponent value="Icons" mark="01" color="background-green" />

    <div class="margin-left-20">
      <a href="http://fontawesome.io/icons/" target="_blank">Font awesome</a>
    </div>
    <div class="container wrap">

      <div class="icon box shadow-small container align-items-center justify-content-around">
        <i class="fa fa-lg fa-home margin-right-10" aria-hidden="true"></i>
        <i class="fa fa-lg fa-envelope margin-right-10" aria-hidden="true"></i>
        <i class="fa fa-lg fa-bars margin-right-10" aria-hidden="true"></i>
        <i class="fa fa-lg fa-coffee" aria-hidden="true"></i>
      </div>

      <div class="icon box shadow-small container align-items-center justify-content-around">
        <i class="fas fa-arrow-right margin-right-10"></i>
        <i class="fas fa-2x fa-arrow-right margin-right-10"></i>
        <i class="fas fa-4x fa-arrow-right margin-right-10"></i>
        <i class="fas fa-6x fa-arrow-right"></i>
      </div>

    </div>
  </div>


</div>
</template>

<script>
import titleComponent from '@/components/titleComponent'

export default {
  name: 'icons',
  components: {
    titleComponent
  },
  data () {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.box {
    border-radius: 10px;
    overflow: hidden;
    cursor: pointer;
    -webkit-transition: 0.3s;
    -o-transition: 0.3s;
    transition: 0.3s;
    padding: 20px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    margin: 20px;
    min-height: 200px;
    flex-basis: 300px;
    flex-grow: 1;
}
.icon {
    i {
        margin: 5px;
    }
}
.text-danger {
    color: #d9534f;
}
</style>



// WEBPACK FOOTER //
// src/components/styleguide/icons.vue